import * as React from "react";

const ScriptFilter = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <path d="M13 16h32v32H13z" />
      <path
        d="M27.072 26.473L22 31.837l5.072 5.374M30.574 42l2.853-20m3.502 15.211L42 31.847l-5.071-5.374"
        stroke="#7B838C"
        strokeWidth={3.333}
        strokeLinejoin="round"
      />
      <path
        d="M17.667 25H15v21.333C15 47.8 16.2 49 17.667 49H39v-2.667H17.667V25z"
        fill="#D2D5D8"
      />
    </g>
  </svg>
);

export default ScriptFilter;

